import React, { Fragment, useEffect } from "react";
import notificationSound from "../img/warning.mp3";

class NotificationIcon extends React.Component {
  audio = new Audio(notificationSound);

  componentDidUpdate(oldProps) {
    if (
      oldProps.notification !== this.props.notification &&
      oldProps.notification < this.props.notification
    ) {
      this.audio.play();
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.notification > 0 ? (
          <div
            style={{
              borderRadius: "50%",
              height: this.props.size,
              width: this.props.size,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#2F80ED",
              color: "#FFE533",
              boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
              marginTop: -10,
              marginRight: -2,
            }}
          >
            <div>{this.props.notification}</div>
          </div>
        ) : (
          <div style={{ display: "none" }}></div>
        )}
      </Fragment>
    );
  }
}

export default NotificationIcon;
